import React from 'react';
import classnames from 'classnames';
import {FieldArray, FieldArrayRenderProps, useFormikContext} from 'formik';
import {FormattedMessage} from 'react-intl';
import FieldLine from '../FieldLine';
import ButtonAction from '../../../../common/components/ui/ButtonAction';
import {useOrderInvoiceFormContext} from '../../contexts/OrderInvoiceFormContext';
import {OrderInvoiceFormValues} from '../../types';
import {InvoiceLine} from '../../../../common/types';
import styles from './FieldLinesArray.module.scss';

const FieldLinesArray = () => {
  const {values} = useFormikContext<OrderInvoiceFormValues>();
  const {defaultLine} = useOrderInvoiceFormContext();

  const addLine = (arrayHelpers: FieldArrayRenderProps, line: InvoiceLine) => () => {
    arrayHelpers.push(line);
  };

  const removeLine = (arrayHelpers: FieldArrayRenderProps, lineIndex: number) => () => {
    arrayHelpers.remove(lineIndex);
  };

  const renderLines = (arrayHelpers: FieldArrayRenderProps) => {
    return (
      <div className={styles.fieldLinesArrayContainer}>
        {mapValues(values, arrayHelpers)}
        <div className={classnames(styles.addButtonContainer)}>
          <div className={styles.colSmall}>
            <ButtonAction
              variant={'link'}
              type={'button'}
              label={(
                <FormattedMessage
                  id={'orderInvoice-line-add'}
                  defaultMessage={'+ Add a new line'}
                />
              )}
              onClick={addLine(arrayHelpers, defaultLine)}
            />
          </div>
          <div className={styles.colSmall}/>
          <div className={styles.colMedium}/>
          <div className={styles.colLarge}/>
        </div>
      </div>
    );
  };

  const mapValues = (values: OrderInvoiceFormValues, arrayHelpers: FieldArrayRenderProps) => {
    return values.lines && values.lines.map((line: InvoiceLine, index: number) => {
      return (
        <FieldLine
          key={index}
          lineIndex={index}
          onRemove={removeLine(arrayHelpers, index)}
        />
      );
    });
  };

  return (
    <FieldArray
      name={'lines'}
      render={renderLines}
    />
  );
};

export default FieldLinesArray;
